import { basemapLayer } from "esri-leaflet"
import { useEffect } from "react"
import { useMap } from "react-leaflet"

import { Layer, tileLayer } from "leaflet"
import "../../styles/map-accessibility.css"
import { GeoJsonLoader } from "./geojson-loader"
import { MapCamera } from "./map-camera"
import { MapDropMarker } from "./map-drop-marker"
import { MapMarkers } from "./map-markers"
import { OtpRoute } from "./otp-route"


export function MapContent() {
  return (
    <>
      <EsriBaseMapLayer />

      <GeoJsonLoader />

      <MapMarkers />

      <OtpRoute />

      <MapCamera />

      <MapDropMarker />
    </>
  )
}

export function EsriBaseMapLayer(): React.ReactNode {
  const map = useMap()
  useEffect(() => {
    if (!map) {
      return
    }

    const layers: (Layer)[] = [
      // OPNVKarte (memomaps)
      tileLayer("https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png", {
        attribution:
          'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }),
      // Esri Topographic as a reliable fallback
      basemapLayer("Topographic", {
        className: "saturate-[0.80]"
      }),
      // tileLayer(
      //   'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {   
      //   className: 'saturate-[0.55]',
      //   attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      // }),
    ]

    let errorCount = 0
    const [opnv, esri] = layers

    esri.addTo(map)
    opnv.addTo(map)

    // If tile errors, remove OPNV so Esri is visible
    const onTileError = () => {
      errorCount += 1
      if (errorCount > 5) {
        if (map.hasLayer(opnv)) {
          map.removeLayer(opnv)
        }
        if (!map.hasLayer(esri)) {
          esri.addTo(map)
        }
      }
    }

    const onTileLoad = () => {
      errorCount = 0
      if (!map.hasLayer(opnv)) {
        opnv.addTo(map)
      }
    }

    opnv.on?.("tileerror", onTileError)
    opnv.on?.("tileload", onTileLoad)

    return () => {
      try {
        opnv.off?.("tileerror")
      } catch (e) {
        console.error(e)
      }
      layers.forEach((l) => l.removeFrom(map))
    }
  }, [map])

  return null
}
